<template>
  <div
    v-if="Object.keys(summaryTotal).length && Object.keys(proceso).length"
    class="container"
  >
    <div class="columns" style="align-items: stretch;">
      <!--   Indicators card (full width when benchmark off, 60% when on)   -->
      <div
        class="column is-flex"
        :class="generalContext.status ? 'is-three-fifths' : 'is-12'"
        style="transition: all 1s; flex-direction: column;"
      >
        <div class="box indicators-card">
          <!--   Tooltip overlay   -->
          <div
            v-if="generalContext && !generalContext.status"
            style="position: absolute; width: 23%; border-radius: 6px; background-color: rgba(0,0,0,0.9); z-index: 2; opacity: 0; transition: opacity 200ms ease, padding 200ms ease;"
            class="has-text-white has-text-left "
          >
            <div id="bodyInterAct" style="padding: 1.25rem;">
              <h1 id="titleInterAct" class="has-text-weight-bold"></h1>
              <p id="textInterAct" style="font-size: 12px"></p>
            </div>
          </div>
          <!--   Table of General Information  -->
          <div
            class="is-justify-center is-flex"
            style="flex-direction: column;"
          >
            <table class="table-general">
              <tr>
                <td colspan="4" class="has-text-centered is-size-3">
                  <div
                    v-on:mouseover="
                      textInter(
                        'climalab',
                        '',
                        summary.total ? summary.total.CClimad.p : 0,
                      )
                    "
                    v-on:mouseout="textClear()"
                    :class="
                      `rango${rangos(
                        summary.total ? summary.total.CClimad.p : 0,
                      )}`
                    "
                  >
                    <div
                      class="is-flex clima-total-row"
                      style="justify-content: center; align-items: center; position: relative;"
                    >
                      <div class="clima-div-empty"></div>
                      <div class="clima-main-flex">
                        <div class="clima-text-block">
                          <div class="clima-title-group">
                            <p class="clima-nombre-line">
                              Clima total
                              <span class="is-hidden-mobile">
                                {{
                                  nombrerangos[
                                    rangos(
                                      summary.total ? summary.total.CClimad.p : 0,
                                    )
                                  ]
                                }}
                              </span>
                              <span class="is-hidden-tablet is-hidden-desktop">
                                ·
                                {{
                                  nombrerangos[
                                    rangos(
                                      summary.total ? summary.total.CClimad.p : 0,
                                    )
                                  ]
                                }}
                              </span>
                            </p>
                            <p class="clima-valor-line">
                              {{
                                summary.total
                                  ? summary.total.CClimad.p
                                  : 0 | number1(1)
                              }}%
                            </p>
                          </div>
                          <div class="clima-content-value">
                            <sparkline
                              v-if="summary.series"
                              :values="seriesValues('CClimad')"
                              :domain-min="sparklineDomain.min"
                              :domain-max="sparklineDomain.max"
                              :width="70"
                              :height="24"
                              class="clima-sparkline"
                            />
                            <variation-chip
                              v-if="summary.processComp"
                              class="clima-variation-chip"
                              :current="summary.total ? summary.total.CClimad.p : 0"
                              :previous="summary.processComp.total.CClimad.p"
                              :label="comparisonLabel"
                              :size="15"
                            />
                          </div>
                        </div>
                        <!-- Badge engagement solo mobile -->
                        <div
                          class="engagement-badge-mobile is-hidden-tablet"
                          :class="
                            `rango${rangos(
                              summary.total ? summary.total.engad.p : 0,
                            )}`
                          "
                          v-on:mouseover.stop
                          v-on:mouseout.stop
                        >
                          <span class="engagement-badge-label">Engagement</span>
                          <div class="engagement-badge-conntent-value">
                            <span class="engagement-badge-value">
                              {{
                                summary.total
                                  ? summary.total.engad.p
                                  : 0 | number1(1)
                              }}%
                            </span>
                            <variation-chip
                              v-if="summary.processComp"
                              :current="summary.total ? summary.total.engad.p : 0"
                              :previous="summary.processComp.total.engad.p"
                              :size="11"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="is-size-5 has-text-centered">
                  <div
                    v-on:mouseover="
                      textInter(
                        'apoyod',
                        '',
                        summary.total ? summary.total.apoyod.p : 0,
                      )
                    "
                    v-on:mouseout="textClear()"
                    :class="
                      `rango${rangos(
                        summary.total ? summary.total.apoyod.p : 0,
                      )}`
                    "
                  >
                    <div
                      class="is-flex tile-row"
                      style="justify-content: space-between; align-items: center;"
                    >
                      <h1 class="tile-title">
                        Apoyo <br class="is-hidden-desktop" />
                        {{
                          summary.total
                            ? summary.total.apoyod.p
                            : 0 | number1(1)
                        }}%
                      </h1>
                      <div v-if="summary.processComp" class="quadrant-indicators">
                        <sparkline
                          v-if="summary.series"
                          :values="seriesValues('apoyod')"
                          :domain-min="sparklineDomain.min"
                          :domain-max="sparklineDomain.max"
                          :width="56"
                          :height="20"
                        />
                        <variation-chip
                          :current="summary.total ? summary.total.apoyod.p : 0"
                          :previous="summary.processComp.total.apoyod.p"
                          :label="comparisonLabel"
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td colspan="2" class="is-size-5 has-text-centered">
                  <div
                    v-on:mouseover="
                      textInter(
                        'innovaciond',
                        '',
                        summary.total ? summary.total.innovaciond.p : 0,
                      )
                    "
                    v-on:mouseout="textClear()"
                    :class="
                      `rango${rangos(
                        summary.total ? summary.total.innovaciond.p : 0,
                      )}`
                    "
                  >
                    <div
                      class="is-flex tile-row"
                      style="justify-content: space-between; align-items: center;"
                    >
                      <h1 class="tile-title">
                        Innovación <br class="is-hidden-desktop" />
                        {{
                          summary.total
                            ? summary.total.innovaciond.p
                            : 0 | number1(1)
                        }}%
                      </h1>
                      <div v-if="summary.processComp" class="quadrant-indicators">
                        <sparkline
                          v-if="summary.series"
                          :values="seriesValues('innovaciond')"
                          :domain-min="sparklineDomain.min"
                          :domain-max="sparklineDomain.max"
                          :width="56"
                          :height="20"
                        />
                        <variation-chip
                          :current="summary.total ? summary.total.innovaciond.p : 0"
                          :previous="summary.processComp.total.innovaciond.p"
                          :label="comparisonLabel"
                        />
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2" class="is-size-5 has-text-centered">
                  <div
                    v-on:mouseover="
                      textInter(
                        'calidadd',
                        '',
                        summary.total ? summary.total.calidadd.p : 0,
                      )
                    "
                    v-on:mouseout="textClear()"
                    :class="
                      `rango${rangos(
                        summary.total ? summary.total.calidadd.p : 0,
                      )}`
                    "
                  >
                    <div
                      class="is-flex tile-row"
                      style="justify-content: space-between; align-items: center;"
                    >
                      <h1 class="tile-title">
                        Calidad <br class="is-hidden-desktop" />
                        {{
                          summary.total
                            ? summary.total.calidadd.p
                            : 0 | number1(1)
                        }}%
                      </h1>
                      <div v-if="summary.processComp" class="quadrant-indicators">
                        <sparkline
                          v-if="summary.series"
                          :values="seriesValues('calidadd')"
                          :domain-min="sparklineDomain.min"
                          :domain-max="sparklineDomain.max"
                          :width="56"
                          :height="20"
                        />
                        <variation-chip
                          :current="summary.total ? summary.total.calidadd.p : 0"
                          :previous="summary.processComp.total.calidadd.p"
                          :label="comparisonLabel"
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td colspan="2" class="is-size-5 has-text-centered">
                  <div
                    v-on:mouseover="
                      textInter(
                        'metasd',
                        '',
                        summary.total ? summary.total.metasd.p : 0,
                      )
                    "
                    v-on:mouseout="textClear()"
                    :class="
                      `rango${rangos(
                        summary.total ? summary.total.metasd.p : 0,
                      )}`
                    "
                  >
                    <div
                      class="is-flex tile-row"
                      style="justify-content: space-between; align-items: center;"
                    >
                      <h1 class="tile-title">
                        Metas <br class="is-hidden-desktop" />
                        {{
                          summary.total
                            ? summary.total.metasd.p
                            : 0 | number1(1)
                        }}%
                      </h1>
                      <div v-if="summary.processComp" class="quadrant-indicators">
                        <sparkline
                          v-if="summary.series"
                          :values="seriesValues('metasd')"
                          :domain-min="sparklineDomain.min"
                          :domain-max="sparklineDomain.max"
                          :width="56"
                          :height="20"
                        />
                        <variation-chip
                          :current="summary.total ? summary.total.metasd.p : 0"
                          :previous="summary.processComp.total.metasd.p"
                          :label="comparisonLabel"
                        />
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>

            <!-- Remaining dimensions: Liderazgo, Recursos, Compensación -->
            <div class="bottom-indicators-row">
              <div
                v-on:mouseover="
                  textInter(
                    'dimenc',
                    'lidd',
                    summary.total ? summary.total.lidd.p : 0,
                  )
                "
                v-on:mouseout="textClear()"
                class="indicator-cell has-text-centered"
                :class="
                  `rango${rangos(summary.total ? summary.total.lidd.p : 0)}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <h2 class="tile-title">Liderazgo</h2>
                  <div v-if="summary.processComp" class="quadrant-indicators quadrant-indicators-sm">
                    <sparkline
                      v-if="summary.series"
                      :values="seriesValues('lidd')"
                      :domain-min="sparklineDomain.min"
                      :domain-max="sparklineDomain.max"
                      :width="44"
                      :height="16"
                    />
                    <variation-chip
                      :current="summary.total ? summary.total.lidd.p : 0"
                      :previous="summary.processComp.total.lidd.p"
                    />
                  </div>
                </div>
              </div>
              <div
                v-on:mouseover="
                  textInter(
                    'dimenc',
                    'recd',
                    summary.total ? summary.total.recd.p : 0,
                  )
                "
                v-on:mouseout="textClear()"
                class="indicator-cell has-text-centered"
                :class="
                  `rango${rangos(summary.total ? summary.total.recd.p : 0)}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <h2 class="tile-title">Recursos</h2>
                  <div v-if="summary.processComp" class="quadrant-indicators quadrant-indicators-sm">
                    <sparkline
                      v-if="summary.series"
                      :values="seriesValues('recd')"
                      :domain-min="sparklineDomain.min"
                      :domain-max="sparklineDomain.max"
                      :width="44"
                      :height="16"
                    />
                    <variation-chip
                      :current="summary.total ? summary.total.recd.p : 0"
                      :previous="summary.processComp.total.recd.p"
                    />
                  </div>
                </div>
              </div>
              <div
                v-on:mouseover="
                  textInter(
                    'dimenc',
                    'compd',
                    summary.total ? summary.total.compd.p : 0,
                  )
                "
                v-on:mouseout="textClear()"
                class="indicator-cell has-text-centered"
                :class="
                  `rango${rangos(summary.total ? summary.total.compd.p : 0)}`
                "
              >
                <div
                  class="is-flex"
                  style="justify-content: space-between; align-items: center;"
                >
                  <h2 class="tile-title">Compensación</h2>
                  <div v-if="summary.processComp" class="quadrant-indicators quadrant-indicators-sm">
                    <sparkline
                      v-if="summary.series"
                      :values="seriesValues('compd')"
                      :domain-min="sparklineDomain.min"
                      :domain-max="sparklineDomain.max"
                      :width="44"
                      :height="16"
                    />
                    <variation-chip
                      :current="summary.total ? summary.total.compd.p : 0"
                      :previous="summary.processComp.total.compd.p"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Engagement circle (always visible, sits at bottom of indicators card) -->
          <div class="engagement-row">
            <div
              v-on:mouseover="
                textInter(
                  'dimenc',
                  'engad',
                  summary.total ? summary.total.engad.p : 0,
                )
              "
              v-on:mouseout="textClear()"
              class="engagement-circle"
              :class="[
                `rango${rangos(summary.total ? summary.total.engad.p : 0)}`,
                { 'engagement-circle-lg': summary.processComp },
              ]"
            >
              <span class="engagement-label">Engagement</span>
              <span class="engagement-value">
                {{ summary.total ? summary.total.engad.p : 0 | number1(1) }}%
              </span>
              <sparkline
                v-if="summary.series"
                :values="seriesValues('engad')"
                :domain-min="sparklineDomain.min"
                :domain-max="sparklineDomain.max"
                :width="46"
                :height="14"
                class="engagement-sparkline"
              />
              <variation-chip
                v-if="summary.processComp"
                class="engagement-variation-chip"
                :current="summary.total ? summary.total.engad.p : 0"
                :previous="summary.processComp.total.engad.p"
                :size="10"
              />
            </div>
          </div>
        </div>
      </div>
      <!--   Benchmark card (40%, only when status on)   -->
      <transition name="fade">
        <div
          v-if="generalContext && generalContext.status"
          class="column is-flex is-two-fifths"
          style="flex-direction: column;"
        >
          <div class="box benchmark-card">
            <div class="content-ctx">
              <div>
                <span class="titleCtx">
                  Benchmark
                </span>
                <div class="headerKpiCtx">
                  <div class="ranking">
                    <img
                      src="@/assets/icons/ranking-linear.svg"
                      alt="rankingIconCL7"
                      width="70"
                    />
                    <div class="info">
                      <span class="title-ranking">{{
                        generalContext.headers.position
                      }}</span>
                      <span
                        v-tooltip.bottom="
                          'Posición actual frente al total de empresas'
                        "
                        class="subtitle-ranking"
                      >
                        Entre
                        <strong>{{
                          generalContext.headers.clients || 0
                        }}</strong>
                        Empresas
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <span class="subtitleCtx">
                Distribución de empresas en
                <strong>Clima total</strong>
              </span>
              <div>
                <GraphChartJs :config="createdLineContext('CClimad')" />
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <evolution-chart :series="summary.series" />
  </div>
</template>

<script>
import { CLIMA_COLORS } from "./climaColors";
import GraphChartJs from "../dashboard/GraphChartJs.vue";
import Sparkline from "./components/sparkline.vue";
import VariationChip from "./components/variationChip.vue";
import EvolutionChart from "./components/evolutionChart.vue";
import json from "./interpretaciones.json";

export default {
  data() {
    return {
      summary: {},
      nombrerangos: {
        1: "Sigamos así",
        2: "Vamos bien",
        3: "Estamos cerca",
        4: "Cuidado",
        5: "Necesita atención pronto",
        6: "Actuemos ya",
        0: "N/A",
      },
      calificaciones: json,
    };
  },
  props: {
    proceso: {
      type: Object,
    },
    summaryTotal: {
      type: Object,
      required: true,
    },
    generalContext: {
      type: Object,
      required: true,
    },
    createdLineContext: Function,
  },
  beforeMount() {
    this.summary = this.summaryTotal;
  },
  methods: {
    textClear() {
      if (this.generalContext.status) return true;
      let b = document.getElementById("bodyInterAct");
      let overlay = b ? b.parentElement : null;

      if (overlay) overlay.style.opacity = "0";
    },
    textInter(group, subGroup, value) {
      if (this.generalContext.status) return true;
      let dato = {};
      if (subGroup.length) {
        dato = this.calificaciones[group].dimensiones[subGroup];
      } else {
        dato = this.calificaciones[group];
      }
      let txt = dato.rango[this.rangos(value)].inter;
      let title = dato.title;

      let b = document.getElementById("bodyInterAct");
      let t = document.getElementById("titleInterAct");
      let p = document.getElementById("textInterAct");
      let overlay = b ? b.parentElement : null;

      p.innerHTML = txt;
      const rangeIdx = this.rangos(value);
      const rangeLabel = this.nombrerangos[rangeIdx];
      const swatchColor = rangeIdx === 0 ? "#a5a5a5" : CLIMA_COLORS[rangeIdx];
      const swatch = `<span style="display:inline-block;width:10px;height:10px;background-color:${swatchColor};border-radius:1px;margin-right:6px;vertical-align:middle;"></span>`;
      t.innerHTML =
        swatch + title + ". " + rangeLabel + "  " + value.toFixed(1) + "%";
      if (overlay) overlay.style.opacity = "1";
    },
    rangos(n) {
      let returned;

      if (n === 0) {
        returned = 6;
      } else if (isNaN(n)) {
        returned = 0;
      } else if (n >= 84) {
        returned = 1; // Sigamos así
      } else if (n >= 70) {
        returned = 2; // Vamos bien
      } else if (n >= 50) {
        returned = 3; // Estamos cerca
      } else if (n >= 30) {
        returned = 4; // Cuidado
      } else if (n >= 16) {
        returned = 5; // Necesita atención pronto
      } else {
        returned = 6; // Actuemos ya
      }

      return returned;
    },
    seriesValues(group) {
      if (!this.summary.series) return [];
      return this.summary.series.map((s) =>
        s.total && s.total[group] ? s.total[group].p : 0,
      );
    },
  },
  computed: {
    comparisonLabel() {
      const fecha = this.summary.processComp && this.summary.processComp.fecha;
      if (!fecha) return "";
      return `vs ${new Date(fecha).getFullYear()}`;
    },
    sparklineDomain() {
      const groups = [
        "CClimad",
        "apoyod",
        "innovaciond",
        "calidadd",
        "metasd",
        "lidd",
        "recd",
        "compd",
        "engad",
      ];
      const all = groups.reduce(
        (acc, group) => acc.concat(this.seriesValues(group)),
        [],
      );
      if (!all.length) return { min: 0, max: 100 };
      const min = Math.min(...all);
      const max = Math.max(...all);
      const padding = Math.max((max - min) * 0.1, 1);
      return {
        min: Math.max(0, min - padding),
        max: Math.min(100, max + padding),
      };
    },
  },
  components: {
    Sparkline,
    VariationChip,
    EvolutionChart,
    GraphChartJs,
  },
};
</script>

<style scoped lang="scss">
.box {
  padding: 2.5rem 2rem;
}

.tile-title {
  text-align: left;
  min-width: 0;
}

.widthTooltip {
  width: 50px !important;
}

.rango1 {
  background-color: var(--clima-1) !important;
  color: white !important;
}

.rango2 {
  background-color: var(--clima-2) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango3 {
  background-color: var(--clima-3) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango4 {
  background-color: var(--clima-4) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango5 {
  background-color: var(--clima-5) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango6 {
  background-color: var(--clima-6) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango0 {
  background-color: #a5a5a5;
}

.table-general {
  width: 80%;
  margin: 0 auto;
  table-layout: fixed;
}

.table-general h2 {
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}

.tile-row {
  padding: 1.5rem;
}

.table-general td {
  padding: 0.5rem;
  min-width: 0;
}

.table-general td div {
  border-radius: 5px;
}

.content-ctx {
  gap: 20px;
  display: flex;
  max-height: 375px;
  border-radius: 6px;
  flex-direction: column;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}

.titleCtx {
  display: block;
  text-align: center;
  padding: 5px 0;
  border-radius: 16px;
  font-size: 18px;
  font-weight: bolder;
  color: #7647ae;
}

.subtitleCtx {
  text-align: left;
}

.headerKpiCtx {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 10px;
}

.ranking {
  gap: 15px;
  display: flex;
  margin: 10px 0;
  border-radius: 6px;
  justify-content: start;
}

.ranking .info {
  display: flex;
  flex-direction: column;
}

.ranking .title-ranking {
  color: #363636;
  text-align: center;
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 1.125;
}

.ranking .subtitle-ranking {
  line-height: normal;
}

.p-2 {
  padding: 5px;
}

.bottom-indicators-row {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
  width: 80%;
  margin: 0.5rem auto 0;
  padding: 0.5rem;
}

.bottom-indicators-row .indicator-cell {
  flex: 1;
  padding: 0.5rem 0.75rem;
  border-radius: 5px;
  cursor: pointer;
  min-width: 0;
}

.bottom-indicators-row .indicator-cell h2 {
  font-size: 1rem;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
}

.column.is-flex {
  margin-bottom: 0 !important;
}

.indicators-card {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 100%;
  width: 100%;
  position: relative;
}

.benchmark-card {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 100%;
  width: 100%;
  padding: 2.6rem 2rem !important;
}

.benchmark-card .content-ctx {
  box-shadow: none;
  padding: 0;
  border-radius: 0;
}

.engagement-row {
  position: absolute;
  top: 1.5rem;
  right: 10%;
  z-index: 1;
}

.engagement-circle {
  width: 95px;
  height: 95px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  text-align: center;
  position: relative;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(50, 50, 50, 0.4);
}

.engagement-circle-lg {
  width: 120px;
  height: 120px;
}

.engagement-circle .engagement-label {
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

.engagement-circle .engagement-value {
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1;
  margin-top: 4px;
}

.engagement-circle .engagement-sparkline {
  margin-top: 2px;
}

.engagement-circle .engagement-variation-chip {
  margin-top: 2px;
  padding: 2px 6px;
  font-size: 0.68rem;
}

.clima-text-block {
  padding: 1.5rem;
  flex: 1;
  gap: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.clima-title-group {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
  text-align: left;
}

.clima-nombre-line {
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 4px;
}

.clima-valor-line {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.clima-content-value {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  min-width: 0;
  flex: 0 1 auto;
}

.clima-div-empty {
  display: block;
}

.clima-sparkline {
  flex: none;
}

.clima-variation-chip {
  flex: none;
}

.quadrant-indicators {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
  min-width: 0;
  flex: 0 1 auto;
}

.quadrant-indicators-sm {
  gap: 6px;
}

// Badge engagement — oculto en desktop, visible en mobile via is-hidden-tablet
.engagement-badge-mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 8px;
  min-width: 72px;
  cursor: pointer;
}

.engagement-badge-mobile .engagement-badge-label {
  font-size: 0.7rem;
  font-weight: 500;
  line-height: 1;
  background-color: rgba(0, 0, 0, 0.09);
  border-radius: 20px;
  padding: 2px 8px;
}

.engagement-badge-conntent-value {
  display: flex;
  align-items: center;
  gap: 4px;
}

.engagement-badge-mobile .engagement-badge-value {
  font-size: 1rem;
  font-weight: 700;
  margin-top: 4px;
}

@media (max-width: 768px) {
  .table-general,
  .table-general tr,
  .table-general td {
    display: block;
    width: 100% !important;
  }

  .table-general h1 {
    font-size: 1rem !important;
  }

  .tile-row {
    padding: 0.75rem !important;
  }

  .box.indicators-card {
    padding: 1.25rem 0.75rem;
  }

  .bottom-indicators-row {
    width: 100%;
    flex-direction: column;
    padding: 0.5rem;
  }

  .bottom-indicators-row .indicator-cell {
    flex: 1 1 100%;
    min-width: unset;
  }

  .bottom-indicators-row .indicator-cell h2 {
    font-size: 0.9rem;
  }

  .indicators-card > div[style*="position: absolute"][style*="width: 23%"] {
    display: none !important;
  }

  // Engagement circle: oculto en mobile
  .engagement-row {
    display: none !important;
  }

  .clima-div-empty {
    display: none;
  }

  .clima-main-flex {
    width: 100%;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
  }

  .clima-text-block {
    gap: 0;
    padding: 0.75rem;
    text-align: left;
    flex-direction: column;
    align-items: flex-start;
  }

  .clima-nombre-line {
    font-size: 0.85rem;
    font-weight: 400;
  }

  .clima-valor-line {
    font-size: 1.4rem;
    font-weight: 700;
  }

  .engagement-circle {
    width: 90px;
    height: 90px;
    margin: 0.5rem auto;
  }

  .engagement-circle .engagement-label,
  .engagement-circle .engagement-value {
    font-size: 0.75rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/climan/ResultadosGeneral.vue